import script from "./TokenListTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenListTable.vue?vue&type=script&lang=ts&setup=true"

import "./TokenListTable.vue?vue&type=style&index=0&id=99c4ea72&lang=scss"

const __exports__ = script;

export default __exports__